import Vue from "vue";
import get from "just-safe-get";
import has from "lodash.has";

import { isDev } from "@/utils/constants";
import Icon from "@/utils/icons";

// Use just-get and has inside our components...
Object.defineProperty(Vue.prototype, "$get", {
  value: get
});

Object.defineProperty(Vue.prototype, "$has", {
  value: has
});

Vue.config.productionTip = isDev;
Vue.component("v-icon", Icon);
